export const ChartColors = [
    '#5296D5', // Blue
    '#7F07E5', // Purple
    '#ef873c', // Orange
    '#6f9654', // Green
    '#235B90', // Dark blue
    '#7c8693', // Dark grey
    '#a53ee0', // Purple
    '#3ee07c', // Light green
    '#facfb1', // Light orange
];

export const InitialColors = [
    '#5296D5', // Blue
    '#753F93', // Dark purple
    '#4FA161', // Green
    '#90BCE4', // Light blue
    '#E19F65', // Light orange
    '#C1468E', // Dark pink
    '#EDCC62', // Light yellow
    '#7ABD88', // Light green
    '#C8A3DC', // Light purple
];
